import { gql } from '@apollo/client';

export const ACKNOWLEDGE_DECLARATION = gql`
  mutation AcknowledgeDeclaration($input: AcknowledgeDeclarationInput!) {
    acknowledgeDeclaration(input: $input) {
      token
    }
  }
`;
